"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const DatePicker_1 = require("./DatePicker");
const DatePicker = (props) => {
    return (0, jsx_runtime_1.jsx)(DatePicker_1.DatePicker, Object.assign({}, props));
};
exports.DatePicker = DatePicker;
